<template>
  <div v-if="shouldShowBanner">
    <banner
      :color-scheme="colorScheme"
      :banner-message="localizedMessage"
      :style="customBannerStyle"
      has-close-button
      @close="dismissBanner"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Banner from 'dashboard/components/ui/Banner.vue';

export default {
  name: 'SystemBanner',
  components: {
    Banner,
  },
  data() {
    return {
      isDismissed: false,
    };
  },
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
    }),
    bannerConfig() {
      return this.globalConfig?.systemBanner || null;
    },
    isEnabled() {
      return this.bannerConfig?.enabled === true;
    },
    bannerType() {
      return this.bannerConfig?.type || 'warning';
    },
    colorScheme() {
      const schemes = {
        error: 'alert',
        warning: 'warning',
        info: 'info',
      };
      return schemes[this.bannerType] || 'warning';
    },
    customBannerStyle() {
      const style = {};
      if (this.bannerConfig?.bgColor) {
        style.backgroundColor = this.bannerConfig.bgColor;
      }
      if (this.bannerConfig?.textColor) {
        style.color = this.bannerConfig.textColor;
      }
      return style;
    },
    localizedMessage() {
      const messages = this.bannerConfig?.messages || {};
      const locale = this.$root.$i18n?.locale || 'en';
      const language = locale.split(/[-_]/)[0];
      // Fallback: locale corrente → lingua base → inglese → primo messaggio disponibile
      return (
        messages[locale] ||
        messages[language] ||
        messages.en ||
        Object.values(messages)[0] ||
        ''
      );
    },
    shouldShowBanner() {
      if (this.isDismissed) return false;
      if (!this.isEnabled) return false;
      if (!this.localizedMessage) return false;
      return true;
    },
  },
  methods: {
    dismissBanner() {
      this.isDismissed = true;
    },
  },
};
</script>
